import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import { APGenericSlot } from '../../../builders/ap_generic_slot_builder';

export interface IMarkAsMetSlotModel {
  currentSlot?: APGenericSlot;
}

export type MarkAsMetSlotModel = ITypedModel<IMarkAsMetSlotModel>;

angular.module('capability-ng-academic-planner').factory(
  'ngMarkAsMetSlotModel',
  (): MarkAsMetSlotModel =>
    new Model<IMarkAsMetSlotModel>({
      currentSlot: undefined
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/mark_as_met/models/mark_as_met_slot_model.ts